import React from 'react'
import { InferGetStaticPropsType } from 'next'
import { localeToCountry } from '@scentregroup/shared/helpers/local-to-country'
import { getDefaultNationalMetaData } from '@scentregroup/shared/helpers/get-default-national-metadata'
import { REVALIDATION_PERIODS } from '@scentregroup/shared/constants'
import { useGetHrefContext } from '@scentregroup/shared/context'
import Layout from '@scentregroup/shared/hub-components/layout'
import { fetchGiftcardsStaticData } from '@scentregroup/shared/hub-components/universal-header'
import GiftCards from '@scentregroup/shared/pages/promotional-page'
// @ts-ignore
import * as withContentPage from '@scentregroup/shared/containers/with-content-page/index.ts'
import { staticHocFetch } from '../lib/static-hoc-fetch'
import { GetStaticProps, GetStaticPropsContext } from '../types/next'
import { makeApolloClient } from '../lib/apolloClient'
import { propsOrNotFound } from '../lib/props-or-not-found'

export const getStaticProps: GetStaticProps = async ({
  locale,
}: GetStaticPropsContext) => {
  const client = makeApolloClient()
  const country = localeToCountry(locale)

  const [giftCardHeaderData, pageData] = await Promise.all([
    fetchGiftcardsStaticData(client, { country }),
    staticHocFetch({
      ...withContentPage,
      client,
      props: {
        match: { path: '/gift-cards' },
        staticContext: { country },
      },
    }),
  ])

  return propsOrNotFound({
    props: {
      country,
      giftCardHeaderData,
      pageData,
    },
    revalidate: REVALIDATION_PERIODS.static,
  })
}

const GiftCardsPage = (
  props: InferGetStaticPropsType<typeof getStaticProps>
) => {
  const { country, giftCardHeaderData, pageData } = props
  const {
    modules,
    metaData: { metaTitle: title, shortDescription },
  } = pageData
  const canonical = useGetHrefContext()()
  const defaultMetaData = getDefaultNationalMetaData({
    country: props.country,
    type: 'gift-cards',
  })

  const metaData = {
    title: title || defaultMetaData.title,
    description: shortDescription || defaultMetaData.description,
    canonical,
  }

  return (
    <Layout
      country={country}
      centre={undefined}
      header={{
        variant: 'gift-cards',
        data: giftCardHeaderData,
        hasBottomMargin: false,
      }}
      metaData={metaData}
      showCVPStrip={false}
    >
      <GiftCards modules={modules} />
    </Layout>
  )
}

export default GiftCardsPage
